import { Uppy } from '@uppy/core'
import XHRUpload from '@uppy/xhr-upload'
import { getAuthFromLocalStorage } from 'app/contexts/AuthenticationProvider/persistAuthToken'
import React, { useState, useEffect, useRef } from 'react'

import ProofFileList from './ProofFileList'
import { CustomDashboardModal, Multiupload } from './styled'
import '@uppy/core/dist/style.min.css'
import '@uppy/dashboard/dist/style.min.css'
import { DeleteModalState, ISponsorRequestMultiuploadProps } from './types'
import { UploadBlockComponent } from './UploadBlockComponent'
import { multiUploadLocaleStrings } from './utils'

export const SponsorRequestMultiupload = ({
  sponsorRequest,
  refetchSponsorRequest,
}: ISponsorRequestMultiuploadProps): JSX.Element => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<DeleteModalState>(
    {}
  )
  const uppyInstance = useRef<Uppy | null>(null)

  useEffect(() => {
    if (!uppyInstance.current) {
      uppyInstance.current = new Uppy({
        restrictions: {
          allowedFileTypes: [
            '.mp4',
            '.mov',
            '.mkv',
            '.avi',
            '.wmv',
            '.flv',
            '.jpeg',
            '.jpg',
            '.png',
            '.svg',
            '.webp',
            '.gif',
            '.bmp',
            '.tiff',
            '.doc',
            '.docx',
            '.xls',
            '.xlsx',
            '.ppt',
            '.pptx',
            '.pdf',
            '.txt',
            '.rtf',
            '.csv',
            '.xml',
            '.numbers',
          ],
          maxFileSize: 50000000,
        },
      })
      uppyInstance.current.use(XHRUpload, {
        endpoint: `${process.env['API_SPONSOR_URL']}/api/v1/user/sponsor_requests/${sponsorRequest.id}/sponsorship_proofs`,
        fieldName: 'sponsorship_proof_files',
        headers: {
          Authorization: `${getAuthFromLocalStorage()}`,
        },
        bundle: false,
      })
      uppyInstance.current.on('upload-error', () => null)
      uppyInstance.current.on('upload-success', () => refetchSponsorRequest())
    }
    return () => {
      uppyInstance.current && uppyInstance.current.close()
    }
  }, [refetchSponsorRequest, sponsorRequest.id])

  const clearUploader = () => {
    setIsUploadModalOpen(false)
    uppyInstance.current?.cancelAll()
  }

  const openDeleteModal = (id: number) => {
    setIsDeleteModalOpen({
      ...isDeleteModalOpen,
      [id]: true,
    })
  }

  const closeDeleteModal = (id: number) => {
    setIsDeleteModalOpen({
      ...isDeleteModalOpen,
      [id]: false,
    })
  }

  return (
    <>
      {sponsorRequest.status === 'finalized' && (
        <>
          <Multiupload>
            <UploadBlockComponent setIsUploadModalOpen={setIsUploadModalOpen} />
            <ProofFileList
              sponsorRequest={sponsorRequest}
              isDeleteModalOpen={isDeleteModalOpen}
              closeDeleteModal={closeDeleteModal}
              refetchSponsorRequest={refetchSponsorRequest}
              openDeleteModal={openDeleteModal}
            />
          </Multiupload>
          {isUploadModalOpen && uppyInstance.current && (
            <CustomDashboardModal
              locale={multiUploadLocaleStrings}
              onRequestClose={clearUploader}
              open={isUploadModalOpen}
              uppy={uppyInstance.current}
            />
          )}
        </>
      )}
    </>
  )
}
